import styled from '@emotion/styled'
import {css} from '@emotion/core'
import {mq} from '../../../../../utils/breakpoints'
import Heading from '../../../../designSystem/Heading'
import {Confetti} from '../../../../../images/Confetti'

export const ConfettiImage = styled(Confetti)`
  position: absolute;
  right: 0;
  left: 0;
  width: 328px;
  margin: auto;
`

export const ConfettiContainer = styled('div')`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin: auto;
  text-align: center;
`

export const ConfettiContent = styled('div')(
  ({theme}) => css`
    z-index: 0;
    margin-top: ${theme.layout.spacing.s600}px;
  `
)

export const MainContainer = styled('div')<{isOverlay: boolean}>(
  ({theme, isOverlay}) => css`
    margin: auto;
    ${isOverlay
      ? 'padding-bottom: 0'
      : `padding-bottom: ${theme.layout.spacing.s900 * 2}px`};
    ${mq.desktopSm(css`
      width: 580px;
      padding-bottom: 0;
    `)}
  `
)

export const PlusText = styled.span(
  ({theme}) => css`
    color: ${theme.colors.privateDealColor};
  `
)

export const TravelWithHeading = styled(Heading)`
  display: flex;
  justify-content: center;
  align-items: center;
`
